import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { SectionTitle, SectionSubtitle } from '../../_common';

import useStyles from './styles';

const CampaignInfo = ({ data }) => {
  const { ciRoot, ciText } = useStyles();

  const arrTextWithLineBreaks = data.description.split('-break-');
  const textWithLineBreaks = arrTextWithLineBreaks.filter(
    (e) => e !== '-break-'
  );

  return (
    <Grid container item xs className={ciRoot}>
      <SectionTitle title="Campaña" />
      <Typography variant="caption" component="span">
        Liga de la campaña:{' '}
        <a
          href={data.link}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={data.link}
        >
          {data.link}
        </a>
      </Typography>
      <SectionSubtitle text={data.title} />
      <Typography component="span" gutterBottom className={ciText}>
        {data.catch_phrase}
      </Typography>
      <SectionTitle title="Descripción" />
      {textWithLineBreaks.map((e, i) => (
        <Typography key={i} component="span" gutterBottom className={ciText}>
          {e}
        </Typography>
      ))}
    </Grid>
  );
};

export default CampaignInfo;
